// "Source: <document> ↗" line above a matching table. Renders nothing until both
// the URL and the display name are known.
import "./Matching.css";

export default function SourceLink({ url, name }) {
  if (!url || !name) return null;
  return (
    <div className="ds-meta mt-source">
      Source:&nbsp;
      <a href={url} target="_blank" rel="noreferrer">
        {name} ↗
      </a>
    </div>
  );
}
